import { render, staticRenderFns } from "./TabApproved.vue?vue&type=template&id=63e72859&scoped=true"
import script from "./TabApproved.vue?vue&type=script&lang=js"
export * from "./TabApproved.vue?vue&type=script&lang=js"
import style0 from "./TabApproved.vue?vue&type=style&index=0&id=63e72859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e72859",
  null
  
)

export default component.exports